var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "template-preview" },
    [
      _c("a-spin", { attrs: { spinning: _vm.loading } }, [
        _vm.template
          ? _c("div", { staticClass: "preview-body" }, [
              _vm.template.description
                ? _c("div", { staticClass: "description" }, [
                    _vm._v(_vm._s(_vm.template.description)),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("section", { staticClass: "section" }, [
                _c("h4", { staticClass: "section-title" }, [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("table_chart"),
                  ]),
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm.$t("tables.templates.tablesSectionTitle", {
                          selected: _vm.selectedCount,
                          total: _vm.template.tables.length,
                        })
                      ) +
                      "\n                    "
                  ),
                  _c(
                    "i",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            content: _vm.$t(
                              "tables.templates.tablesSectionInfo"
                            ),
                          },
                          expression:
                            "{ content: $t('tables.templates.tablesSectionInfo') }",
                        },
                      ],
                      staticClass: "material-icons info-icon",
                    },
                    [_vm._v("help_outline")]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "tables-list" },
                  _vm._l(_vm.template.tables, function (tbl) {
                    return _c(
                      "div",
                      {
                        key: tbl.key,
                        staticClass: "template-table-row",
                        on: {
                          click: function ($event) {
                            return _vm.toggleTable(tbl.key)
                          },
                        },
                      },
                      [
                        _c("a-checkbox", {
                          directives: [
                            {
                              name: "tippy",
                              rawName: "v-tippy",
                              value: {
                                content: _vm.$t(
                                  "tables.templates.tableCheckboxTooltip"
                                ),
                              },
                              expression:
                                "{ content: $t('tables.templates.tableCheckboxTooltip') }",
                            },
                          ],
                          attrs: { checked: !!_vm.selectedTableKeys[tbl.key] },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                            },
                            change: function (e) {
                              return _vm.onTableCheckboxChange(tbl.key, e)
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "table-info" }, [
                          _c("div", { staticClass: "table-name" }, [
                            tbl.icon
                              ? _c("i", { staticClass: "material-icons" }, [
                                  _vm._v(_vm._s(tbl.icon)),
                                ])
                              : _vm._e(),
                            _vm._v(
                              "\n                                " +
                                _vm._s(tbl.name) +
                                "\n                            "
                            ),
                          ]),
                          _vm._v(" "),
                          tbl.description
                            ? _c("div", { staticClass: "table-desc" }, [
                                _vm._v(_vm._s(tbl.description)),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "field-list",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                },
                              },
                            },
                            [
                              _vm._l(_vm.displayedFields(tbl), function (f) {
                                return _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "tippy",
                                        rawName: "v-tippy",
                                        value: {
                                          content: _vm.fieldChipTooltip(f),
                                        },
                                        expression:
                                          "{ content: fieldChipTooltip(f) }",
                                      },
                                    ],
                                    key: f.key,
                                    staticClass: "field-chip",
                                    class: { "is-added": f.isAdded },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(f.name) +
                                        "\n                                    "
                                    ),
                                    _c("small", [
                                      _vm._v(
                                        _vm._s(_vm.fieldTypeLabel(f.fieldType))
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "i",
                                      {
                                        directives: [
                                          {
                                            name: "tippy",
                                            rawName: "v-tippy",
                                            value: {
                                              content: _vm.$t(
                                                "tables.templates.removeField"
                                              ),
                                            },
                                            expression:
                                              "{ content: $t('tables.templates.removeField') }",
                                          },
                                        ],
                                        staticClass:
                                          "material-icons chip-remove",
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.removeField(tbl.key, f)
                                          },
                                        },
                                      },
                                      [_vm._v("close")]
                                    ),
                                  ]
                                )
                              }),
                              _vm._v(" "),
                              _c(
                                "a-popover",
                                {
                                  attrs: {
                                    visible: !!_vm.showTypePicker[tbl.key],
                                    trigger: "click",
                                    placement: "bottom",
                                    overlayClassName:
                                      "template-field-picker-popover",
                                  },
                                  on: {
                                    visibleChange: function (v) {
                                      return _vm.onTypePickerVisibleChange(
                                        tbl.key,
                                        v
                                      )
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "tippy",
                                          rawName: "v-tippy",
                                          value: {
                                            content: _vm.$t(
                                              "tables.templates.addFieldTooltip"
                                            ),
                                          },
                                          expression:
                                            "{ content: $t('tables.templates.addFieldTooltip') }",
                                        },
                                      ],
                                      staticClass: "field-chip add-chip",
                                    },
                                    [
                                      _c(
                                        "i",
                                        { staticClass: "material-icons" },
                                        [_vm._v("add")]
                                      ),
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(
                                            _vm.$t("tables.templates.addField")
                                          ) +
                                          "\n                                    "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "template",
                                    { slot: "content" },
                                    [
                                      _c("FieldSelector", {
                                        on: {
                                          "field-selected": function (t) {
                                            return _vm.onTypeSelected(
                                              tbl.key,
                                              t
                                            )
                                          },
                                          close: function ($event) {
                                            return _vm.closeTypePicker(tbl.key)
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _vm.showAddForm[tbl.key]
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "field-add-form",
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "i",
                                        {
                                          staticClass:
                                            "material-icons add-type-icon",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.pickerTypeIcon(
                                                _vm.newFieldForm[tbl.key] &&
                                                  _vm.newFieldForm[tbl.key]
                                                    .fieldType
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "small",
                                        { staticClass: "add-type-label" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.fieldTypeLabel(
                                                _vm.newFieldForm[tbl.key] &&
                                                  _vm.newFieldForm[tbl.key]
                                                    .fieldType
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.newFieldForm[tbl.key].name,
                                            expression:
                                              "newFieldForm[tbl.key].name",
                                          },
                                        ],
                                        ref: "newFieldInput",
                                        refInFor: true,
                                        staticClass: "add-name-input",
                                        attrs: {
                                          type: "text",
                                          placeholder: _vm.$t(
                                            "tables.templates.fieldNamePlaceholder"
                                          ),
                                        },
                                        domProps: {
                                          value: _vm.newFieldForm[tbl.key].name,
                                        },
                                        on: {
                                          keyup: [
                                            function ($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                _vm._k(
                                                  $event.keyCode,
                                                  "enter",
                                                  13,
                                                  $event.key,
                                                  "Enter"
                                                )
                                              ) {
                                                return null
                                              }
                                              return _vm.saveNewField(tbl.key)
                                            },
                                            function ($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                _vm._k(
                                                  $event.keyCode,
                                                  "esc",
                                                  27,
                                                  $event.key,
                                                  ["Esc", "Escape"]
                                                )
                                              ) {
                                                return null
                                              }
                                              return _vm.cancelAddField(tbl.key)
                                            },
                                          ],
                                          input: function ($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.newFieldForm[tbl.key],
                                              "name",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "i",
                                        {
                                          staticClass:
                                            "material-icons add-confirm",
                                          attrs: {
                                            title: _vm.$t(
                                              "tables.templates.save"
                                            ),
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return _vm.saveNewField(tbl.key)
                                            },
                                          },
                                        },
                                        [_vm._v("check")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "i",
                                        {
                                          staticClass:
                                            "material-icons add-cancel",
                                          attrs: {
                                            title: _vm.$t(
                                              "tables.templates.cancel"
                                            ),
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return _vm.cancelAddField(tbl.key)
                                            },
                                          },
                                        },
                                        [_vm._v("close")]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]),
                      ],
                      1
                    )
                  }),
                  0
                ),
              ]),
              _vm._v(" "),
              _vm.template.relations && _vm.template.relations.length > 0
                ? _c("section", { staticClass: "section" }, [
                    _c("h4", { staticClass: "section-title" }, [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("hub"),
                      ]),
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t("tables.templates.relationsSectionTitle", {
                              count: _vm.template.relations.length,
                            })
                          ) +
                          "\n                    "
                      ),
                      _c(
                        "i",
                        {
                          directives: [
                            {
                              name: "tippy",
                              rawName: "v-tippy",
                              value: {
                                content: _vm.$t(
                                  "tables.templates.relationsSectionInfo"
                                ),
                              },
                              expression:
                                "{ content: $t('tables.templates.relationsSectionInfo') }",
                            },
                          ],
                          staticClass: "material-icons info-icon",
                        },
                        [_vm._v("help_outline")]
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "relations-list" },
                      _vm._l(_vm.template.relations, function (rel, idx) {
                        return _c(
                          "div",
                          {
                            key: idx,
                            staticClass: "relation-row",
                            class: { disabled: !_vm.isRelationActive(rel) },
                          },
                          [
                            _c("span", { staticClass: "rel-name" }, [
                              _vm._v(_vm._s(rel.displayName)),
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "tippy",
                                    rawName: "v-tippy",
                                    value: {
                                      content: _vm.relationSideTooltip(
                                        rel.from
                                      ),
                                    },
                                    expression:
                                      "{ content: relationSideTooltip(rel.from) }",
                                  },
                                ],
                                staticClass: "rel-side",
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.tableName(rel.from.tableKey)) +
                                    "\n                            "
                                ),
                                rel.from.connectionType === "field"
                                  ? _c("small", [
                                      _vm._v("." + _vm._s(rel.from.fieldKey)),
                                    ])
                                  : _vm._e(),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "i",
                              { staticClass: "material-icons rel-arrow" },
                              [_vm._v("arrow_forward")]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "tippy",
                                    rawName: "v-tippy",
                                    value: {
                                      content: _vm.relationSideTooltip(rel.to),
                                    },
                                    expression:
                                      "{ content: relationSideTooltip(rel.to) }",
                                  },
                                ],
                                staticClass: "rel-side",
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.tableName(rel.to.tableKey)) +
                                    "\n                            "
                                ),
                                rel.to.connectionType === "field"
                                  ? _c("small", [
                                      _vm._v("." + _vm._s(rel.to.fieldKey)),
                                    ])
                                  : _vm._e(),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "tippy",
                                    rawName: "v-tippy",
                                    value: {
                                      content: _vm.$t(
                                        "tables.templates.relationBidirectional",
                                        {
                                          from: _vm.tableName(
                                            rel.from.tableKey
                                          ),
                                          to: _vm.tableName(rel.to.tableKey),
                                        }
                                      ),
                                    },
                                    expression:
                                      "{ content: $t('tables.templates.relationBidirectional', { from: tableName(rel.from.tableKey), to: tableName(rel.to.tableKey) }) }",
                                  },
                                ],
                                staticClass: "rel-badge",
                              },
                              [_vm._v("⇄")]
                            ),
                            _vm._v(" "),
                            _c(
                              "i",
                              {
                                directives: [
                                  {
                                    name: "tippy",
                                    rawName: "v-tippy",
                                    value: {
                                      content: _vm.$t(
                                        "tables.templates.relationExplanation",
                                        {
                                          from: _vm.tableName(
                                            rel.from.tableKey
                                          ),
                                          to: _vm.tableName(rel.to.tableKey),
                                        }
                                      ),
                                    },
                                    expression:
                                      "{ content: $t('tables.templates.relationExplanation', { from: tableName(rel.from.tableKey), to: tableName(rel.to.tableKey) }) }",
                                  },
                                ],
                                staticClass: "material-icons info-icon",
                              },
                              [_vm._v("help_outline")]
                            ),
                            _vm._v(" "),
                            !_vm.isRelationActive(rel)
                              ? _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "tippy",
                                        rawName: "v-tippy",
                                        value: {
                                          content: _vm.$t(
                                            "tables.templates.skipReasonTooltip"
                                          ),
                                        },
                                        expression:
                                          "{ content: $t('tables.templates.skipReasonTooltip') }",
                                      },
                                    ],
                                    staticClass: "rel-skip",
                                  },
                                  [
                                    _c("i", { staticClass: "material-icons" }, [
                                      _vm._v("block"),
                                    ]),
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.$t(
                                            "tables.templates.relationSkipped"
                                          )
                                        ) +
                                        "\n                        "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        )
                      }),
                      0
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.template.demoRecords
                ? _c(
                    "section",
                    { staticClass: "section demo-section" },
                    [
                      _c("a-switch", {
                        model: {
                          value: _vm.withDemoData,
                          callback: function ($$v) {
                            _vm.withDemoData = $$v
                          },
                          expression: "withDemoData",
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "demo-info" }, [
                        _c("div", { staticClass: "demo-title" }, [
                          _vm._v(
                            _vm._s(_vm.$t("tables.templates.demoToggleTitle"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "demo-subtitle" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.$t("tables.templates.demoToggleSubtitle")
                              ) +
                              "\n                    "
                          ),
                        ]),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "actions" },
                [
                  _c(
                    "SupsisButton",
                    {
                      attrs: { disabled: _vm.applying },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("cancel")
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("tables.templates.cancel")) +
                          "\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "SupsisButton",
                    {
                      attrs: {
                        primary: "",
                        loading: _vm.applying,
                        disabled: _vm.selectedCount === 0 || _vm.applying,
                      },
                      on: { click: _vm.apply },
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("check"),
                      ]),
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t("tables.templates.applyButton", {
                              count: _vm.selectedCount,
                            })
                          ) +
                          "\n                "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }